import { autobind } from 'frontools/decorators/Autobind';
import { debounce } from 'frontools/decorators/Debounce';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import ArrayUtils from 'frontools/utils/ArrayUtils';

declare var SplitText;

export class SplitTextAnim extends AbstractDispatcher {

    public static ENDED     : string = 'ended';

    private _text           : string;
    private _spans          : Array<HTMLElement>;

    constructor(private _elWrapper: HTMLElement) {
        super();
        if (!this._elWrapper.textContent.length) return;

        this._text = this._elWrapper.textContent; 

        this._elWrapper.innerText = '';

        this._spans = [];

        for (let i = 0; i<this._text.length; i++) {
            this._spans[i] = document.createElement('SPAN');
            // this._spans[i].innerHTML = (this._text[i] == ' ') ? '&emsp;' : this._text[i];
            this._spans[i].innerText = this._text[i];
            this._spans[i].style.position = 'relative'; 
            // this._spans[i].style.display = 'inline-block';
            this._spans[i].style.margin = '0';
            this._spans[i].style.padding = '0';
            this._elWrapper.appendChild(this._spans[i]);
        }

        this._spans = ArrayUtils.randomize(this._spans);

        TweenMax.set(this._elWrapper,{opacity:1});
        TweenMax.staggerFrom(this._spans, 0.6, {opacity:0, top:-1000, ease:Back.easeOut, easeParams:[.5], onComplete: this._refill }, 0.2, this._dispatchEnded);
    }   

    @autobind
    private _dispatchEnded() {
        this.dispatch({type: SplitTextAnim.ENDED});
    }
    
    @autobind
    @debounce(1000)
    private _refill() {
        // this._elWrapper.innerHTML = this._text;
    }

    public get elWrapper() : HTMLElement {
        return this._elWrapper;
    }
}